<ngb-pagination
        [collectionSize]="collectionSize"
        [pageSize]="pageSize"
        [boundaryLinks]="true"
        [maxSize]="5"
        [ellipses]="false"
        [rotate]="true"
        [(page)]="page"
        (pageChange)="outputPageNumber($event)">
    <ng-template ngbPaginationFirst
                 class="pagination-text-button"><span data-cy="pagination-first-button">First</span>
    </ng-template>
    <ng-template ngbPaginationPrevious>
        <app-tooltip [dynamic]="false" message="Go to previous page" class="display-inline-flex">
            <span class="pagination-arrow-button iwp-icon-gen_back" data-cy="pagination-previous-button"></span>
        </app-tooltip>
    </ng-template>
    <ng-template ngbPaginationNumber let-pageNumber>
        <span [attr.data-cy]="'pagination-number-button-' + pageNumber">{{pageNumber}}</span>
    </ng-template>    
    <ng-template ngbPaginationNext class="pagination-text-button">
        <app-tooltip [dynamic]="false" message="Go to next page" class="display-inline-flex">
            <span class="pagination-arrow-button iwp-icon-gen_continue" data-cy="pagination-next-button"></span>
        </app-tooltip>
    </ng-template>
    <ng-template class="pagination-text-button"
                 ngbPaginationLast><span data-cy="pagination-last-button">Last</span>
    </ng-template>
</ngb-pagination>
